import ApiBaseURLProps from "../other/apiBaseURL";
import axios from "axios";
import { authorizationHeader } from "./apiConfig";

class SecurityService {
  changePassword(opassword, password) {
    var bodyFormData = new FormData();
    bodyFormData.append("opassword", opassword);
    bodyFormData.append("password", password);

    return axios.post(
      ApiBaseURLProps.apiBaseURL + "/security/change-password",
      bodyFormData,
      {
        ...authorizationHeader(),
      }
    );
  }
  auth(username, password) {
    var bodyFormData = new FormData();
    bodyFormData.append("username", username);
    bodyFormData.append("password", password);
    bodyFormData.append("grant_type", "password");

    return axios.post(
      ApiBaseURLProps.apiBaseURL + "/security/oauth/token",
      bodyFormData,
      {
        auth: {
          username: "customer",
          password: "customer",
        },
      }
    );
  }

  register(data) {
    return axios.post(ApiBaseURLProps.apiBaseURL + "/security/register", data, {
      auth: {
        username: "customer",
        password: "customer",
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getUsernameSuggestion(data) {
    var bodyFormData = new FormData();

    return axios.get(
      ApiBaseURLProps.apiBaseURL +
      "/security/username-suggestion" +
      Object.keys(data).reduce(
        (a, v) => a + (a ? "&" : "?") + v + "=" + data[v],
        ""
      ),
      { data: bodyFormData }
    );
  }

  async getUserInfo(history) {
    const data = authorizationHeader();
    return await axios
      .get(ApiBaseURLProps.apiBaseURL + "/security/info", {
        ...authorizationHeader(),
      })
      .then((response) => {
        const data = response.data;
        sessionStorage.setItem("user_info", JSON.stringify(data));

        if (data.passwordChanged) window.location.href = "/kyc/dashboard";
        else history.push("/change-password");
      })
      .catch((error) => {
        throw error;
      });
  }

  validateEmail(email) {
    return axios.get(
      ApiBaseURLProps.apiBaseURL + "/security/validate-email?email=" + email
    );
  }

  validateForgotPasswordData(params) {
    return axios.get(
      ApiBaseURLProps.apiBaseURL +
      `/security/validate-forgot-password-data?` +
      Object.keys(params)
        .filter((k) => params[k])
        .map((k) => "&" + k + "=" + params[k])
        .reduce((a, v) => a + v, "")
    );
  }

  resetPassword(data) {
    console.log(data, "inside post api");
    return axios.get(
      ApiBaseURLProps.apiBaseURL +
      "/security/reset-password?newPassword=" +
      data.password +
      "&verificationCode=" +
      data.verificationCode
      //  +"&email=" +
      //  data.email
    );
  }

  async getRefreshToken() {
    let bodyFormData = new FormData();
    bodyFormData.append(
      "refresh_token",
      sessionStorage.getItem("refresh_token")
    );
    bodyFormData.append("grant_type", "refresh_token");
    return await axios.post(
      ApiBaseURLProps.apiBaseURL + "/security/oauth/token",
      bodyFormData,
      {
        // auth: {
        //   username: "customer",
        //   password: "customer",
        // },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("refresh_token")}`
        }

      }
    );
  }
  generateAccessToken = (toast, history) => {
    console.log("generate access token called");
    SecurityService.getRefreshToken()
      .then((response) => {
        if (response.data.jti) {
          sessionStorage.setItem("token", response.data.jti);
          sessionStorage.setItem("refresh_token", response.data.jti);
          sessionStorage.setItem("expires_in", eval(Date.now()));
        } else {
          toast.error("Error Message", "Error. Please Login!!!")
          history.push("/login");
        }
      })
      .catch((error) => {
        toast.error("Error Message", error.response && error.response.data && error.response.data.msg)
      });
  };

  generateCaptcha() {
    return axios.post(ApiBaseURLProps.apiBaseURL + "/file/captcha/new", null, {
      // auth: {
      //   username: "customer",
      //   password: "customer",
      // },
      // headers: {
      //   "Content-Type": "application/json",
      // },
    });
  }
}


export default new SecurityService();
